<template>
  <div>
    <div class="row text-white inner-row" style="background: #00bbff">
      <div class="col-md-11" style="text-align: left">
        <i class="tim-icons icon-minimal-up" v-on:click="changeView('toRow')" style="margin-right: 10px"></i>
        <b>{{object.tsr.basis.name + ' - ' + object.tsr.ipr.client.name}}</b>
      </div>
      <div class="col-md-1" style="text-align: right">
        <i class="tim-icons icon-pencil" v-on:click="changeView('toEdit')" style="margin-right: 10px"></i>
      </div>
    </div>

    <simple-row :name="'Дата ввода'" :value="convertDate(object.initialDate)"></simple-row>
    <simple-row :name="'Дата установки'" :value="convertDate(object.executingDate)"></simple-row>
    <simple-row :name="'Заметки'" :value="fieldView(object.note)"></simple-row>

    <br/>
    <kit-items v-if="showItems" :item="item.object" @hide="showItems = false"></kit-items>
    <p v-else> Установленные изделия <i v-on:click="showItems = true" class="tim-icons icon-minimal-down"></i></p>

  </div>
</template>
<script>

 import SimpleRow from "@/components/SimpleRow";
 import {longAsStringDate} from "@/services/utils";

 export default {
   components: {
     SimpleRow
   },
   props:{
     item: {}
   },
   data() {
     return {
       tableKey: 0,
       object: this.item.object,
       showItems: false
     }
   },
   methods: {
     convertDate(time) {
       return time ? longAsStringDate(time) : "-";
     },
     fieldView(data) {
       return data ? data : '-';
     },
     changeView(how) {
       this.$emit(how);
     }
   }
 }
</script>
<style>
</style>
